import {
	Box,
	Button,
	Container,
	TextField,
	Typography,
	Paper,
	CircularProgress,
	Alert,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { login } from "../api/auth";
import { useEffect } from "react";

interface LoginFormInputs {
	email: string;
	password: string;
}

export default function LoginPage() {
	const { register, handleSubmit } = useForm<LoginFormInputs>();
	const navigate = useNavigate();

	const mutation = useMutation({
		mutationFn: login,
		onSuccess: (data) => {
			localStorage.setItem("token", data.access_token);
			navigate("/dashboard");
		},
	});

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) navigate("/dashboard");
	}, [navigate]);

	const onSubmit = (data: LoginFormInputs) => {
		mutation.mutate(data);
	};

	return (
		<Container maxWidth="xs">
			<Paper elevation={4} sx={{ p: 4, mt: 12, bgcolor: "background.paper" }}>
				<Typography variant="h5" align="center" gutterBottom>
					Admin Login
				</Typography>

				{/* Вывод ошибки авторизации */}
				{mutation.isError && (
					<Alert severity="error" sx={{ mt: 2, mb: 1 }}>
						{(mutation.error as any)?.response?.data?.message ||
							"Authentication failed"}
					</Alert>
				)}

				<Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
					<TextField
						margin="normal"
						fullWidth
						label="Email"
						{...register("email", { required: true })}
					/>
					<TextField
						margin="normal"
						fullWidth
						label="Password"
						type="password"
						{...register("password", { required: true })}
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						sx={{ mt: 3 }}
						disabled={mutation.isPending}
					>
						{mutation.isPending ? <CircularProgress size={24} /> : "Login"}
					</Button>
				</Box>
			</Paper>
		</Container>
	);
}
